import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";

const GetGlobalReconciliationTypeList = () => {
  const [reconciliationType, setReconciliationType] = useState([]);
  const getIndustry = async () => {
    try {
      let data = await TLinkApi.get("/global/reconciliation/type-list");
      setReconciliationType(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getIndustry();
    // eslint-disable-next-line
  }, []);
  return { reconciliationType };
};

export default GetGlobalReconciliationTypeList;
